import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { MobileHeader } from "../../../stories/MobileHeader/MobileHeader";
import classes from "./DashboardMobile.module.css";
import { InputWithSearchIcon } from "../../../stories/InputWithSearchIcon/InputWithSearchIcon";
import { MobileFilter } from "../../../stories/MobileFilter/MobileFilter";
import MobileBottomTab from "../../../stories/MobileBottomTab/MobileBottomTab";
import { useLocation } from "react-router";
import { MyLessonCard } from "../../../stories/MyLessonCard/MyLessonCard";
import {
  coachDemoImg,
  LessonRequestsIconSvg,
  StarIconRed,
  TransactionIconRedSvg,
  VisaSvg,
} from "../../../constant/imagePath";
import { MyLessonCardMobile } from "../../../stories/MyLessonCard/MyLessonCardMobile";
import { PerformanceEvaluationCard } from "../../../stories/PerformanceEvaluationCard/PerformanceEvaluationCard";
import PerformanceEvaluationMobileCard from "../../../stories/PerformanceEvaluationCard/PerformanceEvaluationMobileCard";
import Fonts from "../../../stories/assets/Fonts";
import Colors from "../../../stories/assets/Colors";
import { ReactSVG } from "react-svg";
import MobileFilterModal from "../../../components/Modals/StudentFlow/Dashboard/MobileFilterModal/MobileFilterModal";
import { MobileFooter } from "../../../stories/MobileFooter/MobileFooter";
import { PaginationComponent } from "../../../stories/Pagination/Pagination";
import { Button } from "../../../stories/Button/Button";
import { SettingsPhoneTwoTone } from "@mui/icons-material";
import CancelBooking from "../../../components/Modals/StudentFlow/Dashboard/CancelBooking/CancelBooking";
import ReportAProblemModal from "../../../components/Modals/StudentFlow/Dashboard/ReportAProblem/ReportAProblem";

function NoData({ heading, icon }) {
  return (
    <Row className={classes.noData}>
      <Col md={12} className={classes.col1}>
        <div>
          <ReactSVG
            src={icon}
            beforeInjection={(svg) =>
              svg.classList.add(classes.icon, classes.mb16)
            }
          />
          <h4
            style={{
              ...Fonts.h3,
              fontSize: "24px",
              lineHeight: "32px",
              color: Colors.neutralShadesOfNero,
            }}
            className={classes.mb16}
          >
            {heading}
          </h4>
          <p
            style={{
              ...Fonts.p1,
              fontSize: "14px",
              color: Colors.neutralShadesOfDimGray,
            }}
            className={classes.mb24}
          >
            You haven’t booked any lessons yet. But as soon as you do they’ll
            appear here.
          </p>
        </div>
      </Col>
      <Col md={12} className={classes.col2}>
        <Button primary={true} size={"Large"}>
          Look for a coach
        </Button>
      </Col>
    </Row>
  );
}

function MyLessons({ data }) {
  const [show, setShow] = useState(false);
  return (
    <Row className={"g-0"}>
      {data?.length == 0 && (
        <Col md={12}>
          <NoData
            heading={"You haven’t booked a lesson yet"}
            icon={LessonRequestsIconSvg}
          />
        </Col>
      )}
      {data?.length > 0 &&
        data?.map((item) => (
          <Col md={12}>
            <MyLessonCardMobile
              data={item}
              onClick1={() => setShow(true)}
              onClick2={() => setShow(true)}
            />
          </Col>
        ))}

      {/* <ReportAProblemModal show={show} setShow={setShow} /> */}
      {/* <CancelBooking show={show} setShow={setShow} /> */}
    </Row>
  );
}
function PerformanceEvaluation({ data }) {
  return (
    <Row className={`g-0 ${classes.evalCards}`}>
      {data?.length == 0 && (
        <Col md={12}>
          <NoData
            heading={"You have no performance evaluation"}
            icon={StarIconRed}
          />
        </Col>
      )}

      {data?.length > 0 &&
        data?.map((item) => (
          <Col md={12}>
            <PerformanceEvaluationMobileCard data={item} />
          </Col>
        ))}
    </Row>
  );
}
function TransactionHistory({ data }) {
  return (
    <>
      <Row className={`g-0 ${[classes.pt24].join(" ")}`}>
        {data?.length == 0 && (
          <Col md={12}>
            <NoData
              heading={"You have no transaction history"}
              icon={TransactionIconRedSvg}
            />
          </Col>
        )}

        {data?.length > 0 && (
          <Col md={12} className={classes.component3Div}>
            <Row className={"g-0"}>
              <Col md={10} sm={10} xs={10}>
                <p
                  style={{ ...Fonts.h9, color: Colors.neutralShadesOfDimGray }}
                >
                  Date
                </p>
              </Col>
              {/* <Col md={5} sm={5} xs={5}>
                <p
                  style={{ ...Fonts.h9, color: Colors.neutralShadesOfDimGray }}
                >
                  Payment method
                </p>
              </Col> */}
              <Col md={2} sm={2} xs={2}>
                <p
                  style={{ ...Fonts.h9, color: Colors.neutralShadesOfDimGray }}
                >
                  Total
                </p>
              </Col>
              {data?.map((item) => {
                return (
                  <Row className={`g-0 ${classes.tr}`}>
                    <Col md={10} sm={10} xs={10}>
                      {item?.type == "upcoming" && (
                        <span
                          style={{
                            ...Fonts.h7,
                            lineHeight: "24px",
                            fontFamily: "inter-600",
                            color: Colors.neutralShadesOfPinkSwan,
                            marginBottom: "4px",
                          }}
                        >
                          {item?.lessonTime} (upcoming)
                        </span>
                      )}
                      <p
                        style={{
                          ...Fonts.p2,
                          color: Colors.neutralShadesOfNero,
                        }}
                      >
                        {item?.requestType} with {item?.user?.displayName}
                      </p>
                    </Col>
                    {/* <Col md={5} sm={5} xs={5}>
                      <div className={classes.iconWithText}>
                        <ReactSVG
                          src={VisaSvg}
                          beforeInjection={(svg) =>
                            svg.classList.add(classes.icon)
                          }
                        />
                        <span
                          style={{
                            ...Fonts.p2,
                            color: Colors.neutralShadesOfNero,
                          }}
                        >
                          &#8226;&#8226;&#8226; &#8226;&#8226;&#8226;
                          &#8226;&#8226;&#8226; {item?.cardNumber}
                        </span>
                      </div>
                    </Col> */}
                    <Col md={2} sm={2} xs={2}>
                      <h5
                        style={{
                          ...Fonts.h6,
                          color:
                            item?.type == "upcoming"
                              ? Colors.neutralShadesOfPinkSwan
                              : Colors.neutralShadesOfNero,
                        }}
                      >
                        ${item?.amount}
                      </h5>
                    </Col>
                  </Row>
                );
              })}
            </Row>
          </Col>
        )}
      </Row>
    </>
  );
}

const myLessonsData = [
  {
    userData: {
      displayName: "Tyler",
      photo: coachDemoImg,
    },
    date: "Aug 27,2021",
    time: "12:30PM-2:30Pm",
    location: "DeWitt Clinton Park, W54thy St, New York, NY",
    type: "pending",
    income: "$64",
    requestType: "1-on-1 Tennis Lesson",
    timeLeft: "6 days",
  },
  {
    userData: {
      displayName: "Tyler",
      photo: coachDemoImg,
    },
    date: "Aug 27,2021",
    time: "12:30PM-2:30Pm",
    location: "DeWitt Clinton Park, W54thy St, New York, NY",
    type: "accepted",
    income: "$64",
    requestType: "1-on-1 Tennis Lesson",
    timeLeft: "6 days",
  },
];
const performanceEvaluationData = [
  {
    userData: {
      displayName: "Tyler",
      photo: coachDemoImg,
    },
    date: "Aug 27,2021",
    time: "12:30PM-2:30Pm",
    location: "DeWitt Clinton Park, W54thy St, New York, NY",
    type: "pending",
    income: "$64",
    requestType: "1-on-1 Tennis Lesson",
    timeLeft: "6 days",
  },
  {
    userData: {
      displayName: "Tyler",
      photo: coachDemoImg,
    },
    date: "Aug 27,2021",
    time: "12:30PM-2:30Pm",
    location: "DeWitt Clinton Park, W54thy St, New York, NY",
    type: "accepted",
    income: "$64",
    requestType: "1-on-1 Tennis Lesson",
    timeLeft: "6 days",
  },
  {
    userData: {
      displayName: "Benedict Cumberbatch",
      photo: coachDemoImg,
    },
    date: "Aug 27,2021",
    time: "12:30PM-2:30Pm",
    location: "DeWitt Clinton Park, W54thy St, New York, NY",
    type: "accepted",
    income: "$64",
    requestType: "1-on-1 Tennis Lesson",
    timeLeft: "6 days",
  },
];
const transactionHistoryData = [
  {
    amount: "75",
    cardNumber: "3456",
    requestType: "1 on 1 Tennis Lesson",
    user: {
      displayName: "John Johnson",
    },
    type: "upcoming",
    lessonTime: "11/12/2022",
  },
  {
    amount: "75",
    cardNumber: "3456",
    requestType: "1 on 1 Tennis Lesson",
    user: {
      displayName: "John Johnson",
    },
    // type:'upcoming',
    lessonTime: "11/12/2022",
  },
  {
    amount: "75",
    cardNumber: "3456",
    requestType: "1 on 1 Tennis Lesson",
    user: {
      displayName: "John Johnson",
    },
    // type:'upcoming',
    lessonTime: "11/12/2022",
  },
];

function StudentDashboardMobile() {
  const location = useLocation();
  const [searchValue, setSearchValue] = useState("");
  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const [filterText, setFilterText] = useState("My lessons");
  const [currentPage, setCurrentPage] = useState(1);
  const [paginatedData, setpaginatedData] = useState([]);
  const [data, setData] = useState(myLessonsData);

  const options = [
    "My lessons",
    "Performance evaluation",
    "Transaction history",
  ];
  const pagelimit = 2;

  useEffect(() => {
    setpaginatedData(() => {
      const startIndex = currentPage * pagelimit - pagelimit;
      const endIndex = startIndex + pagelimit;
      return data.slice(startIndex, endIndex);
    });
  }, [currentPage, data]);

  useEffect(() => {
    if (filterText == "My lessons") {
      setData(myLessonsData);
    } else if (filterText == "Performance evaluation") {
      setData(performanceEvaluationData);
    } else {
      setData(transactionHistoryData);
    }
  }, [filterText]);

  return (
    <div className={classes.page}>
      <Container fluid className={classes.mainContainer}>
        <Row className={`g-0 ${classes.mainRow}`}>
          <Col md={12} className={classes.padding16}>
            <Col md={12}>
              <MobileHeader isLogo={true} />
            </Col>
            <Col md={12} className={classes.mt24}>
              <InputWithSearchIcon
                isShowFilter={true}
                state={searchValue}
                setter={setSearchValue}
                onFilter={setIsOpenFilter}
              />
            </Col>
            <Col md={12} className={classes.mt12}>
              <MobileFilter
                filters={options}
                setter={setFilterText}
                state={filterText}
              />
            </Col>
            {/* Main Content */}
            <Col md={12} className={classes.mt32}>
              {filterText == "My lessons" && <MyLessons data={paginatedData} />}
              {filterText == "Performance evaluation" && (
                <PerformanceEvaluation data={paginatedData} />
              )}
              {filterText == "Transaction history" && (
                <TransactionHistory data={paginatedData} />
              )}
            </Col>
            {data?.length > 0 && (
              <Col md={12} className={classes.pagination}>
                <PaginationComponent
                  totalPages={Math.ceil(data?.length / pagelimit)}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                />
              </Col>
            )}
          </Col>
          <Col md={12} className={classes.footer}>
            <MobileFooter />
          </Col>
        </Row>
      </Container>

      {/* Filter Modal */}
      {isOpenFilter && (
        <MobileFilterModal show={isOpenFilter} setShow={setIsOpenFilter} />
      )}
    </div>
  );
}

export default StudentDashboardMobile;
